import { hbs } from 'ember-cli-htmlbars';
const __COLOCATED_TEMPLATE__ = hbs("<a href={{@glossaryLink}} data-test-id=\"glossary-link\">\n  {{svg-jar \"info\" class=\"o--icon--sm u--m__l__xs\"}}\n</a>\n", {"contents":"<a href={{@glossaryLink}} data-test-id=\"glossary-link\">\n  {{svg-jar \"info\" class=\"o--icon--sm u--m__l__xs\"}}\n</a>\n","moduleName":"later/components/glossary-link.hbs","parseOptions":{"srcName":"later/components/glossary-link.hbs"}});
import templateOnly from '@ember/component/template-only';

export default templateOnly();
